import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/store'

Vue.use(Router)

/*
 * To define breadcrumbs for a route:
 * - meta: {crumbs: []} gives a default link back to the dashboard
 * - add additional crumbs as needed for deeper navigation
 * - omit if no crumbs are needed
 */

const router = new Router(
    {
        mode: 'history', // NB: this is important to allow either Yii or Vue to handle the same URL routes
        scrollBehavior(to, from, savedPosition) {
            return {x: 0, y: 0}
        },
        routes: [
            {
                path: '/',
                component: require('@/pages/Home').default,
            },
            {
                path: '/docs',
                component: require('@/pages/Docs').default,
            },
            {
                path: '/admin',
                component: require('@/pages/Admin').default,
            },
            {
                path: '/doc/id/:docId',
                component: require('@/pages/DocEdit').default,
                props: (route) => ({docId: route.params.docId}),
                //meta: {crumbs: [{to: '/practitioner/patients', label: 'Our Patients'}]}
            },

            {
                path: '/legacy/letterNamings',
                component: require('@/pages/LetterNamings').default,
            },
            {
                path: '/legacy/mazes',
                component: require('@/pages/Mazes').default,
            },
            {
                path: '/legacy/oralReadings',
                component: require('@/pages/OralReadings').default,
            },
            {
                path: '/legacy/writtenExpressions',
                component: require('@/pages/WrittenExpressions').default,
            },
        ],
    }
)

// var adminState = {
//     name: 'admin',
//     url: '/admin',
//     component: 'admin'
// };
//
// var progressMonitorState = {
//     name: 'progressMonitor',
//     url: '/progressMonitor',
//     component: 'progressMonitor'
// };
//
// var chartDogState = {
//     name: 'chartdog',
//     url: '/chartdog',
//     component: 'chartdog'
// };
//
// var behaviorReportState = {
//     name: 'behaviorReport',
//     url: '/behaviorReport',
//     component: 'behaviorReport'
// };




export default router


